import ProfessionalLayout from "@/components/layout/ProfessionalLayout";
import AnalyticsDashboard from "@/components/analytics/AnalyticsDashboard";

export default function AnalyticsPage() {
  return (
    <ProfessionalLayout>
      <div>
        <AnalyticsDashboard />
      </div>
    </ProfessionalLayout>
  );
}
